import { useQueries } from "@tanstack/react-query";
import { PurchaseOrderService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { PurchaseOrder } from "src/types/database/purchaseOrder";

export const useChildPurchaseOrders = (
  childPurchaseOrderIds: string[] | undefined,
  purchaseOrderService: PurchaseOrderService
) => {
  const queries = useQueries({
    queries:
      childPurchaseOrderIds && childPurchaseOrderIds.length > 0
        ? childPurchaseOrderIds.map((childId) => ({
            queryKey: queryKeys.purchaseOrder(childId),
            queryFn: async () => {
              try {
                return await purchaseOrderService.getPurchaseOrderById(childId);
              } catch (error) {
                if (error instanceof APIError && error.statusCode === 404) {
                  return null;
                }
                throw error;
              }
            },
            enabled: !!childId,
            retry: false
          }))
        : []
  });

  const childPurchaseOrders: (PurchaseOrder | null)[] = queries.map((query) => query.data ?? null);
  const isLoading = queries.some((query) => query.isLoading);
  const hasError = queries.some((query) => query.error);
  const errors = queries.map((query) => query.error).filter(Boolean);

  return {
    childPurchaseOrders: childPurchaseOrders.filter((po): po is PurchaseOrder => po !== null),
    isLoading,
    hasError,
    errors
  };
};
